import * as axiosRequestsConfiguration from '../configuration/axios-configuration/axios.token-configuration';
import * as axiosErrosInterceptor from '../configuration/axios-configuration/axios.erros.interceptor';

export const configure = () => {
    axiosRequestsConfiguration.setAuthToken();
    axiosRequestsConfiguration.setBaseUrl();
    axiosErrosInterceptor.addErrorsInterceptor();
};
